import { RoutingNumberError, assertRoutingNumber } from 'shared';
/**
 * Stays quiet while the number is still being typed: an empty or short value
 * returns no message, a non-numeric value or a failed ABA check digit does.
 */
function validateRoutingNumberInput(value) {
    try {
        assertRoutingNumber(value);
    }
    catch (error) {
        if (!(error instanceof RoutingNumberError))
            throw error;
        if (error.reason === 'required' || error.reason === 'length') {
            return undefined;
        }
        return error.message;
    }
    return undefined;
}
export default validateRoutingNumberInput;
